/* eslint-disable max-len */
import { SvgProps } from './types'

export const HouseIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="61"
      height="56"
      viewBox="0 0 61 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M51.3919 31.0511V54.0001H9.33337V30.4434" 
        stroke={drawColor} 
        strokeWidth="2.5" 
      />
      <path
        d="M54.6068 29.9864L30.4013 10.5964L6.19007 29.9864L2 24.7503L30.4013 2L58.8027 24.7503L54.6068 29.9864Z" 
        stroke={drawColor} 
        strokeWidth="2.5" 
      />
      <path
        d="M40.4872 27.27H19.9459V47.8113H40.4872V27.27Z" 
        stroke={drawColor} 
        strokeWidth="2.5" 
      />
      <path
        d="M30.2194 27.27V47.8172" 
        stroke={drawColor} 
        strokeWidth="2.5" 
      />
      <path
        d="M40.4872 37.5435H19.9459" 
        stroke={drawColor} 
        strokeWidth="2.5" 
      />
      <path
        d="M10.5197 15.1612V4.40845H18.5433V8.41736" 
        stroke={drawColor} 
        strokeWidth="2.5" 
      />
    </svg>
  )
}
